<template>
  <section id="skill" class="resume">
    <div class="resume-content">
      <!-- Subtitle -->
      <p class="headline__subtitle animate-headline">
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="currentColor">
          <path d="M5.6,12.6c-0.5-0.8-0.7-2.4-1.7-3.5c-1-1-2.7-1.2-3.5-1.7C-0.1,7-0.1,6,0.4,5.6c0.8-0.5,2.3-0.6,3.5-1.8
            C5,2.8,5.1,1.2,5.6,0.4C6-0.1,7-0.1,7.4,0.4c0.5,0.8,0.7,2.4,1.8,3.5c1.2,1.2,2.6,1.2,3.5,1.7c0.6,0.4,0.6,1.4,0,1.7
            C11.8,7.9,10.2,8,9.1,9.1c-1,1-1.2,2.7-1.7,3.5C7,13.1,6,13.1,5.6,12.6z" />
        </svg>
        <span>Skills</span>
      </p>

      <!-- Skill Grid -->
      <div class="tools-grid">
        <div v-for="(skill, index) in skills" :key="index" class="tools-card">
          <h6 class="tools-caption mb-1">{{ skill.name }}</h6>
          <div class="skill-tags">
            <span v-for="(tag, i) in skill.tags" :key="i" class="rounded-tag">
              {{ tag }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "SkillSection",
  data() {
    return {
      skills: [
        { name: "E2E Automation Testing", tags: ["Playwright", "Cypress"] },
        { name: "API Testing", tags: ["Postman", "Mocha & Chai"] },
        { name: "Performance Testing", tags: ["K6"] },
        { name: "Defect Tracking", tags: ["Jam", "ClickUp", "Jira"] },
        { name: "CI/CD Pipelines", tags: ["Github Actions"] },
        { name: "Test Cases Management & Documentation", tags: ["Qase.io"] },
      ],
    };
  },
};
</script>

<style scoped>
.headline__subtitle {
  display: inline-flex;
  align-items: center;
  height: 3.4rem;
  padding: 0 1.4rem;
  border-radius: var(--_radius-s);
  border: 1px solid var(--stroke-elements);
  font: 700 18px/3.3rem var(--_font-default);
  margin-bottom: 1rem;
  /* color: #fff; */
}
.resume-content {
margin-top: 40px;
}
.tools-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  /* 2 kolom */
  gap: 1.5rem;
  margin-top: 1.5rem;
  margin-bottom: 2rem;
}

@media (min-width: 768px) {
  .tools-grid {
    grid-template-columns: repeat(2, 1fr);
    /* tetap 2 kolom di tablet */
  }
}

@media (min-width: 1024px) {
  .tools-grid {
    grid-template-columns: repeat(2, 1fr);
        margin-right: 40px;

    /* tetap 2 kolom di desktop */
  }
}

.tools-card {
  background: rgba(255, 255, 255, 0.03);
  border-radius: 16px;
  padding: 1.25rem;
  text-align: left;
  transition: box-shadow 0.3s ease;
  border: 2px solid rgba(255, 255, 255, 0.1);
}

.tools-card:hover {
  border-radius: var(--_radius-s);
  border: none;
  box-shadow: 0 0 16px rgb(52, 180, 203);
}



.skill-tags {
  margin-top: 0.5rem;
}

.rounded-tag {
  background-color: #2a2a2a;
  /* color: #fff; */
  border-radius: var(--_radius-s);
  padding: 0.3rem 0.8rem;
  /* font-size: 12px; */
  margin-right: 0.5rem;
  margin-bottom: 0.3rem;
  /* display: inline-block; */
}
</style>
